import React from "react";
import { AppFooter } from "@loanbossinc/component-library";
import { getYear } from "date-fns";

const LBFooter = () => (
  <AppFooter
    phoneNumber=""
    supportEmail="support@loanboss.com"
    address={`© ${getYear(new Date())} LoanBoss LLC. All rights reserved. 2825 South Blvd. Charlotte, NC 28209`}
  />
);

export default LBFooter;
